import type { SpringError } from "@p-ban/common/src/core/api/createHttpClient"
import createReviver from "@p-ban/common/src/core/api/createReviver"
import { deserializeDate } from "@p-ban/common/src/core/api/deserializer"
import type { ValueOf } from "@p-ban/common/src/types"
import type COGNITIVE_MEDIA from "@p-ban/core/src/seminar/constant/COGNITIVE_MEDIA"
import type SEMINAR_CATEGORY from "@p-ban/core/src/seminar/constant/SEMINAR_CATEGORY"
import type SEMINAR_STATUS from "@p-ban/core/src/seminar/constant/SEMINAR_STATUS"
import type USER_TYPE from "@p-ban/core/src/user/constant/USER_TYPE"

import httpClient from "../../../api/httpClient"
import SEMINAR_END_POINT from "./SEMINAR_END_POINT"

export type SeminarValues = {
  seminarId: number
  seminarCategory: ValueOf<typeof SEMINAR_CATEGORY>["value"]
  seminarName: string
  seminarDate: Date
  seminarStatus: ValueOf<typeof SEMINAR_STATUS>["value"]
  personalInfoProvidedTo: string | null
  purposeOfPersonalInfoUse: string | null
  onlineSeminar: boolean
  site: string
  startTime: Date
  endTime: Date
  accountRequired: boolean
}
export type SeminarEntryValue = {
  seminarId: number
  personal: ValueOf<typeof USER_TYPE>["value"] | null
  familyName: string
  firstName: string
  familyNameKana: string
  firstNameKana: string
  company: string
  department: string
  email: string
  telNo: string
  requestMessage: string
  cognitiveMedia: ValueOf<typeof COGNITIVE_MEDIA>["value"] | null
  cognitiveMediaOther: string
  participateIndividualConsultations: boolean | null
  consultation: string
}

type EntryUser =
  | {
      isLoggedIn: true
      personal: ValueOf<typeof USER_TYPE>["value"]
      familyName: string
      firstName: string
      familyNameKana: string | null
      firstNameKana: string | null
      company: string | null
      department: string | null
      email: string
      telNo: string | null
    }
  | {
      isLoggedIn: false
      personal: null
      familyName: null
      firstName: null
      familyNameKana: null
      firstNameKana: null
      company: null
      department: null
      email: null
      telNo: null
    }

const seminarApi = {
  async getSeminar(seminarId: string) {
    return httpClient.get<SeminarValues>(SEMINAR_END_POINT.GET_SEMINAR, {
      queryParams: { seminarId },
      reviver: createReviver(
        { path: ["seminarDate"], deserialize: deserializeDate },
        { path: ["startTime"], deserialize: deserializeDate },
        { path: ["endTime"], deserialize: deserializeDate }
      ),
    })
  },
  async getEntryUser() {
    return httpClient.get<EntryUser>(SEMINAR_END_POINT.GET_ENTRY_USER)
  },
  async entry(data: SeminarEntryValue) {
    return httpClient.post<"", SpringError<typeof data>>(SEMINAR_END_POINT.ENTRY, data)
  },
} as const

export default seminarApi
